module.exports = __webpack_public_path__ + "static/media/ScrollDownBlack.3b35a825.svg";